import React, {FC, memo, useCallback, useState} from 'react';

import * as ShareReportTriggerS from '../../components/ShareReportTrigger/ShareReportTrigger.styles';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {profileShared} from '../../services/analytics';
import {profilePage} from '../../util/urls';
import * as S from './ShareProfileTrigger.styles';

export const SHARE_PROFILE_QS_KEY = `shareProfileType`;

export enum ShareProfileType {
  copy = `copy`,
}

export function isShareProfileType(str: string): str is ShareProfileType {
  return str in ShareProfileType;
}

type ShareProfileTriggerProps = {
  entityName: string;
  fontSize?: number;
};

export const ShareProfileTrigger: FC<ShareProfileTriggerProps> = memo(
  ({entityName, fontSize}) => {
    const [modalOpen, setModalOpen] = useState(false);

    const {origin, host} = window.location;
    const encodedPathname = encodeURI(profilePage(entityName));

    const [isMagicLinkAnimated, setIsMagicLinkAnimated] = useState(false);
    const animateMagicLink = useCallback(() => {
      setIsMagicLinkAnimated(false);
      setTimeout(() => {
        setIsMagicLinkAnimated(true);
      });
    }, []);

    return (
      <>
        <S.ShareTrigger
          name={`share`}
          onClick={() => setModalOpen(true)}
          fontSize={fontSize}
        />
        {modalOpen && (
          <S.ShareModal open onClose={() => setModalOpen(false)}>
            <S.ShareModalClose
              name={`close`}
              onClick={() => setModalOpen(false)}
            />
            <S.ShareModalContent>
              <S.ShareModalHeader>Share Profile</S.ShareModalHeader>
              <ShareReportTriggerS.CopyableLink
                isAnimated={isMagicLinkAnimated}
                text={`${host}${encodedPathname}`}
                copyText={`${origin}${encodedPathname}?${SHARE_PROFILE_QS_KEY}=${ShareProfileType.copy}`}
                toastText="Link copied"
                onClick={() => {
                  animateMagicLink();
                  profileShared({
                    entityName,
                    shareType: ShareProfileType.copy,
                  });
                }}
              />
            </S.ShareModalContent>
          </S.ShareModal>
        )}
      </>
    );
  }
);
